import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_URL } from '../../configurations/server-config';

@Injectable({
  providedIn: 'root'
})
export class AgenceService {

  constructor(private http: HttpClient) { }

  saveagence(agence: any): any {
    return this.http.post(`${API_URL}/agences`, agence, {
      observe: 'response',
    });
  }

  updateagence(agence: any): any {
    return this.http.put(`${API_URL}/agences`, agence);
  }

  getAllagence(page= 0, size= 10): any {
    return this.http.get(`${API_URL}/agences?page=${page}&size=${size}`);
  }

  getAllagencelist(): any {
    return this.http.get(`${API_URL}/agencelist`);
  }

  getAllagencelist2(): any {
    return this.http.get(`${API_URL}/agencelists`);
  }

  getagenceinfo(id: any): any {
    return this.http.get(`${API_URL}/agenceinfo/${id}`);
  }

  adddestinations(agence: any): any {
    return this.http.post(`${API_URL}/setdestinations`, agence);
  }

  getagencedestinations(id: any): any {
    return this.http.get(`${API_URL}/getagencedest/${id}`);
  }

  deleteagence(id: any): any {
    return this.http.delete(`${API_URL}/deleteagence/${id}`);
  }
}
